const dictData = {
  yes_or_no: [
    { label: "是", value: 1 },
    { label: "否", value: 0 },
  ],
  metting_type: [
    {
      label: "党委会",
      value: "MT3001",
    },
    {
      label: "党组会",
      value: "MT3002",
    },
    {
      label: "党支部会议",
      value: "MT3014",
    },
    {
      label: "股东会",
      value: "MT3003",
    },
    {
      label: "股东大会",
      value: "MT3015",
    },
    {
      label: "股东",
      value: "MT3016",
    },
    {
      label: "董事会",
      value: "MT3004",
    },
    {
      label: "董事会专门委员会",
      value: "MT3017",
    },
    {
      label: "董事长办公会",
      value: "MT3005",
    },
    {
      label: "董事长",
      value: "MT3006",
    },
    {
      label: "总经理办公会",
      value: "MT3007",
    },
    {
      label: "总裁办公会",
      value: "MT3008",
    },
    {
      label: "职代会",
      value: "MT3013",
    },
    {
      label: "其他",
      value: "MT3011",
    },
  ],
  dmms_metting_type: [
    {
      label: "党组会",
      value: 0,
    },
    {
      label: "董事会",
      value: 1,
    },
    {
      label: "董事长专题会",
      value: 2,
    },
    {
      label: "总经理办公会",
      value: 3,
    }
  ],
  result: [
    { value: 0, label: "失败" },
    { value: 1, label: "成功" },
  ],
  // 消息类型
  msg_type: [
    { label: "高层会议", value: 0 },
    { label: "综合性会议", value: 1 },
    { label: "专项会议", value: 2 },
  ],
  // 审议类型
  deliberate_type: [
    {
      label: "传达",
      value: 0,
    },
    {
      label: "听取",
      value: 1,
    },
    {
      label: "审议",
      value: 2,
    },
    {
      label: "审议研究",
      value: 3,
    },
    {
      label: "研究讨论",
      value: 4,
    }
  ],
  collect_status: [
    {
      label: "草稿",
      value: 0,
    },
    {
      label: "审核中",
      value: 1,
    },
    {
      label: "驳回",
      value: 2,
    },
    {
      label: "审核完成",
      value: 3,
    },
    {
      label: "线下审核",
      value: 4,
    },
    {
      label: "线下审核完成",
      value: 5,
    }
  ],
  /**议题状态 */
  command_status: [
    {
      label: "草稿",
      value: 0,
    },
    {
      label: "审核中",
      value: 1,
    },
    {
      label: "已驳回",
      value: 2,
    },
    {
      label: "待排会",
      value: 3,
    },
    {
      label: "已排会",
      value: 4,
    },
  ],
  /** 归档状态 */
  archive_status: [
    { label: "已归档", value: 1 },
    { label: "未归档", value: 0 },
    { label: "四性监测中", value: 2 },
    { label: "归档失败", value: 3 },
  ],
  /** 资料类型-归档 */
  attach_type: [
    { label: "会议纪要", value: 0 },
    { label: "会议请示（议题汇总请示）", value: 1 },
    { label: "会议通知", value: 2 },
    { label: "会议安排", value: 3 },
    { label: "决议", value: 5 },
    { label: "授权委托书", value: 6 },
    { label: "会议记录", value: 7 },
  ],
};
export default dictData;
